import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "coinbase-logo",
  "use": "coinbase-logo-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol aria-label=\"Coinbase logo\" role=\"img\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" id=\"coinbase-logo\">\n    <path d=\"M24,36c-6.63,0-12-5.37-12-12s5.37-12,12-12c5.94,0,10.87,4.33,11.82,10h12.09C46.89,9.68,36.58,0,24,0 C10.75,0,0,10.75,0,24s10.75,24,24,24c12.58,0,22.89-9.68,23.91-22H35.82C34.87,31.67,29.94,36,24,36z\" fill=\"#0052FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol